import * as React from 'react';
import PropTypes from 'prop-types';
import {Tab,Tabs,Box,Typography} from "@material-ui/core"
import Audiotesting from "../CheckAudioVideo/Audiotesting"
import Videotesting from "../CheckAudioVideo/Videotesting"
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import Audiotesting from "../components/Audiotesting"
// import Finalwebcamcomp from "../components/Finalwebcamcomp"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'blue' }}>
        <Tabs value={value} indicatorColor="primary" onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Audio" {...a11yProps(0)} />
          <Tab label="Video" {...a11yProps(1)} />
          {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Audiotesting/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Videotesting />
      </TabPanel>
    </Box>
  );
}
